import { render, staticRenderFns } from "./SearchQuotes.vue?vue&type=template&id=6c8f64c4&scoped=true"
import script from "./SearchQuotes.vue?vue&type=script&lang=js"
export * from "./SearchQuotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8f64c4",
  null
  
)

export default component.exports